export default [
  {
    key: 'kindName',
    label: '種別',
    style: {
    }
  }, 
  {
    key: 'name',
    label: '費用',
    style: {
    }
  }, 
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/cost/listHeader.js